module.exports = __webpack_public_path__ + "assets/img/logintitle.9886e738.png";